// ADVISORY CATALOG
export const START_FETCHING_FIRMWARE_ADVISORIES = 'START_FETCHING_FIRMWARE_ADVISORIES';
export const GET_FIRMWARE_ADVISORIES_SUCCESS = 'GET_FIRMWARE_ADVISORIES_SUCCESS';
export const GET_FIRMWARE_ADVISORIES_ERROR = 'GET_FIRMWARE_ADVISORIES_ERROR';

// WRITES - create, edit and revoke all run through one job-backed pipeline
export const START_SAVING_FIRMWARE_ADVISORY = 'START_SAVING_FIRMWARE_ADVISORY';
export const SAVE_FIRMWARE_ADVISORY_SUCCESS = 'SAVE_FIRMWARE_ADVISORY_SUCCESS';
export const SAVE_FIRMWARE_ADVISORY_ERROR = 'SAVE_FIRMWARE_ADVISORY_ERROR';
// Leaving the page mid-write is not an outcome to report, but `saving` still has to be released:
// the slice outlives the route, so a flag left raised disables the row actions on the next visit
export const SAVE_FIRMWARE_ADVISORY_ABORTED = 'SAVE_FIRMWARE_ADVISORY_ABORTED';

// MODALS - held in the store because the sidebar's "Add advisory" action is dispatched from
// Administrator/index.js, a sibling of the page rather than a parent of the modal
export const SHOW_FIRMWARE_ADVISORY_FORM_MODAL = 'SHOW_FIRMWARE_ADVISORY_FORM_MODAL';
// Create mode with some fields filled in, e.g. from an approval just made on the hardware inventory
// page. Kept apart from the show action above, whose payload is an advisory to edit: a partial
// advisory passed there would open the form in edit mode.
export const SHOW_SEEDED_FIRMWARE_ADVISORY_FORM_MODAL = 'SHOW_SEEDED_FIRMWARE_ADVISORY_FORM_MODAL';
export const HIDE_FIRMWARE_ADVISORY_FORM_MODAL = 'HIDE_FIRMWARE_ADVISORY_FORM_MODAL';
export const SHOW_FIRMWARE_ADVISORY_REVOKE_MODAL = 'SHOW_FIRMWARE_ADVISORY_REVOKE_MODAL';
export const HIDE_FIRMWARE_ADVISORY_REVOKE_MODAL = 'HIDE_FIRMWARE_ADVISORY_REVOKE_MODAL';
